import {v3} from "../short3.js";
import Maths3 from "../Maths3.js";
import AbstractIntersectionHandler from "./AbstractIntersectionHandler.js";

//statische Hilfsvariablen, die in isIntersectingTriangle benutzt werden,
//aber aus Performancegründen nicht bei jedem Methodenaufruf neu erzeugt werden

const plane = new THREE.Plane();
const ray = new THREE.Ray();
const pointHolder1 = v3();
const pointHolder2 = v3();

/**
 * Abstrakte Basisklasse für alle IntersectionHandler, deren Geometrie eine zentrale
 * Achse (Ray) aufweist, auf die alle Schnittpunkte projeziert werden
 */
export default class AbstractAxisIntersectionHandler extends AbstractIntersectionHandler {

    constructor(objects,options) {
        super(objects,options);
        
    }

    isIntersectionSphere (sphere) {
        return this.getGeometryInWorldSpace().isIntersectionSphere(sphere);
    }

    intersectTriangle (a, b, c, backfaceCulling, worldMatrix, pushIntersectionCallback) {
        const geomLocal = this.getGeometryInLocalSpace();
        let rayIsInTriangle = false;
        let point = null;
        if (this.isIntersectingTriangle(a,b,c)) {
            if (Maths3.isTriangleDegenerated(a,b,c)) {
                return;
            }
            ray.set(geomLocal.origin,geomLocal.direction);
            point = ray.intersectTriangle(a, b, c, backfaceCulling, pointHolder1);
            if (!point) {
                plane.setFromCoplanarPoints(a,b,c);
                const d = geomLocal.direction.dot( plane.normal );
                if ( d > 0 && backfaceCulling ) {
                    return;
                }
                point = pointHolder1.copy(a).add(b).add(c).multiplyScalar(1/3);
                point = ray.closestPointToPoint(point, pointHolder2);
            } else {
                rayIsInTriangle = true;
            }
        }
        if (point) {
            point.applyMatrix4(worldMatrix);
            const geomWorld = this.getGeometryInWorldSpace();
            const distance = point.distanceTo(geomWorld.origin);
            pushIntersectionCallback({
                point: point.clone(),
                distance,
                rayIsInTriangle,
            });
        }
    }

    flushIntersectionsOfCurrentObject (intersections) {
        if (intersections.length==0) {
            return;
        }

        intersections.sort((a,b)=>a.distance<b.distance);
        const nearestExact = intersections.find(i=>i.rayIsInTriangle);

        if (nearestExact) {
            this.intersectioncallback(nearestExact);
            return;
        }

        const medianInexact = intersections[Math.floor(intersections.length/2)];
        this.intersectioncallback(medianInexact);
    }

}
